export function DashboardDocsSentToIRS() {
  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4'>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
        <div className='w-full flex flex-col items-center'>
          <div className='w-full flex flex-col items-center gap-4'>
            <p className='font-bold text-xl text-center'>No Additional Step Required at this Time.</p>
          </div>
        </div>
      </div>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
        <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
        <div className='w-full flex flex-col items-start gap-4'>
          <p className='text-xl text-[#646464]'><span className='font-bold'>IRS Receives Your Packet -</span> The IRS will receive the forms you've submitted. We are closely monitoring the delivery to ensure everything is processed correctly.</p>
          <p className='text-xl text-[#646464]'><span className='font-bold'>Confirmation of Receipt -</span> Once we receive confirmation from the IRS that your packet has been received, we will begin processing your Express Refund.</p>
          <p className='text-xl text-[#646464]'><span className='font-bold'>Processing Your Express Refund -</span> After confirmation, your Express Refund will be deposited via ACH as quickly as possible.</p>
          <p className='text-xl text-[#646464]'>You will be notified once the IRS has received your packet and when your Express Refund is in progress.</p>
        </div>
      </div>
    </div>
  )
}